// extracted by mini-css-extract-plugin
export default {"input":"If0Y4I","phone":"_wlc22","zip":"maLPHa","birthdayAmount":"Zs7roi","firstName":"aDWiwK","targetWeight":"kuxDvh"};